module.exports = __webpack_public_path__ + "img/tel1.42164a47.png";